import React, { useEffect, useState, useCallback } from 'react';
import { Tags } from '../../../api/services/next';
import PropTypes from 'prop-types';
import DropDown from '../dropdown';
import { onError } from '../../../components/shared/messages';

const TagsDropDown = ({
  IsSystem,
  ChainId,
  HotelId,
  EntityTypeId,
  onAddTag,
  data,
  ...rest
}) => {
  const [tags, setTags] = useState([]);

  useEffect(() => {
    if (data) {
      setTags(data);
    } else {
      try {        
        Tags.GetTags({ IsSystem, ChainId, HotelId }).then(setTags);            
      } catch (error) {
        onError(error);
      }
    }
  }, [data]);

  const onAddItem = useCallback(
    async (e, { value }) => {
      const newTag = await Tags.AddTag({
        Tag1: value,
        IsSystem,
        ChainId,
        HotelId,
        EntityTypeId,
      });
      setTags((prevTags) => [...prevTags, newTag]);

      if (onAddTag) {
        onAddTag(newTag);
      }
    },
    [IsSystem, ChainId, HotelId, EntityTypeId]
  );

  return (
    <DropDown
      data={tags}
      onAddItem={onAddItem}
      search
      textField='Tag1'
      valueField='Id'
      allowAdditions
      {...rest}
    />
  );
};

TagsDropDown.propTypes = {
  IsSystem: PropTypes.bool,
  data: PropTypes.array,
  ChainId: PropTypes.number,
  HotelId: PropTypes.number,
  EntityTypeId: PropTypes.number,
  onAddTag: PropTypes.func,
};

export default TagsDropDown;
